<template lang="pug">
modal#show-signature-failure-modal(
  :process-button-label='$t("modal.showSignatureFailure.retryButton")'
  :show-cancel-button='false'
  :title='$t("modal.showSignatureFailure.title")'
  @process='closeModal'
  ref='modal'
)
  .text {{ $t('modal.showSignatureFailure.message') }}
  .text-center.my-4
    img.img-fluid(src='/img/ilustrations/signature-failure.svg')
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'ShowSignatureFailureModal',
  components: {
    Modal,
  },
  methods: {
    closeModal() {
      this.$refs.modal.close();
    },
  },
};
</script>
